import { Routes } from '@angular/router';


export const content: Routes = [

  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'dashboard', loadChildren: () => import('./dashboards/dashboard.module').then(m => m.DashboardModule)
  }
]

